"use strict";
angular.module('televisionManageRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('manageconfig.productmanage.television.manage', {
            url: '/manage?siteid',
            views: {
                'main@manageconfig.productmanage': {
                    templateUrl: './manageConfig/productManageMent/television/blankPage/blankPage_tpl.html',
                    controller: ''
                }
            }
        })
        .state('manageconfig.productmanage.television.manage.channelmanage', {
            url: '/channelmanage',
            views: {
                'main@manageconfig.productmanage.television.manage': {
                    templateUrl: './manageConfig/productManageMent/television/televisionChannelManage/televisionChannelManage_tpl.html',
                    controller: 'televisionChannelManageCtrl'
                }
            }
        })
        .state('manageconfig.productmanage.television.manage.distributionconfiguration', {
            url: '/distributionconfiguration', 
            views: {
                'main@manageconfig.productmanage.television.manage': {
                    templateUrl: './manageConfig/productManageMent/television/distributionconfiguration/distributionconfiguration_tpl.html',
                    controller: 'televisionDistributionConfigurationCtrl'
                }
            }
        })
    }]);